// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rQmqG-IdleState-module_root{display:flex;flex-direction:column;flex-grow:1}.ZpWms-IdleState-module_tabs{margin-bottom:1.3333333333rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "rQmqG-IdleState-module_root",
	"tabs": "ZpWms-IdleState-module_tabs"
};
export default ___CSS_LOADER_EXPORT___;
